<template>
  <div>
    <el-tabs v-model="tab">
      <el-tab-pane label="内容列表" name="content" />
      <el-tab-pane label="内容类型" name="type" />
    </el-tabs>

    <div v-show="tab === 'type'">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openType()">新增类型</el-button>
      </div>
      <el-table :data="types" border stripe v-loading="typeLoading">
        <el-table-column label="图标" width="80">
          <template slot-scope="{ row }">
            <img v-if="row.iconUrl" :src="row.iconUrl" class="icon-thumb" />
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="120" />
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ row.status === 'ON' ? '启用' : '停用' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openType(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-show="tab === 'content'">
      <div class="toolbar">
        <el-select v-model="filterTypeId" clearable placeholder="内容类型" style="width:180px" @change="loadContents">
          <el-option v-for="t in types" :key="t.id" :label="t.name" :value="t.id" />
        </el-select>
        <el-button type="primary" icon="el-icon-plus" @click="openContent()">新增内容</el-button>
      </div>
      <el-table :data="contents" border stripe v-loading="contentLoading">
        <el-table-column label="封面" width="90">
          <template slot-scope="{ row }">
            <img v-if="row.coverUrl" :src="row.coverUrl" class="thumb" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="160" />
        <el-table-column label="类型" width="120">
          <template slot-scope="{ row }">{{ typeName(row.typeId) }}</template>
        </el-table-column>
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ row.status === 'ON' ? '上架' : '下架' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openContent(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="typeForm.id ? '编辑类型' : '新增类型'" :visible.sync="typeVisible" width="480px">
      <el-form :model="typeForm" label-width="90px">
        <el-form-item label="名称" required><el-input v-model="typeForm.name" /></el-form-item>
        <el-form-item label="图标">
          <el-upload :action="'#'" :http-request="elUploadHttpRequest" :show-file-list="false" :on-success="onTypeIcon" accept="image/*">
            <el-button size="small" plain>上传图标</el-button>
          </el-upload>
          <div v-if="typeForm.iconUrl" class="icon-preview">
            <img :src="typeForm.iconUrl" alt="图标预览" />
            <el-button type="text" style="color:#f56c6c" @click="$set(typeForm, 'iconUrl', '')">清除</el-button>
          </div>
          <el-input v-model="typeForm.iconUrl" style="margin-top:8px" placeholder="或粘贴图标地址" />
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="typeForm.sortNo" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="typeForm.status">
            <el-radio label="ON">启用</el-radio>
            <el-radio label="OFF">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="typeVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveType">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="contentForm.id ? '编辑内容' : '新增内容'"
      :visible.sync="contentVisible"
      width="880px"
      top="5vh"
      append-to-body
    >
      <el-form :model="contentForm" label-width="90px">
        <el-form-item label="类型" required>
          <el-select v-model="contentForm.typeId" style="width:100%">
            <el-option v-for="t in types" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required><el-input v-model="contentForm.title" /></el-form-item>
        <el-form-item label="封面">
          <el-upload :action="'#'" :http-request="elUploadHttpRequest" :show-file-list="false" :on-success="onContentCover" accept="image/*">
            <el-button size="small" plain>上传封面</el-button>
          </el-upload>
          <div v-if="contentForm.coverUrl" class="cover-preview">
            <img :src="contentForm.coverUrl" alt="封面预览" />
            <el-button type="text" style="color:#f56c6c" @click="$set(contentForm, 'coverUrl', '')">清除</el-button>
          </div>
          <el-input v-model="contentForm.coverUrl" placeholder="或粘贴图片地址" style="margin-top:8px" />
        </el-form-item>
        <el-form-item label="正文">
          <rich-editor v-if="contentVisible" v-model="contentForm.body" />
        </el-form-item>
        <el-form-item label="排序"><el-input-number v-model="contentForm.sortNo" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="contentForm.status">
            <el-radio label="ON">上架</el-radio>
            <el-radio label="OFF">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="contentVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveContent">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listContentTypes, saveContentType, listContents, saveContent } from '../../api/cms'
import RichEditor from '../../components/RichEditor.vue'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'CmsContent',
  components: { RichEditor },
  data() {
    return {
      tab: 'content',
      types: [],
      contents: [],
      typeLoading: false,
      contentLoading: false,
      saving: false,
      filterTypeId: null,
      typeVisible: false,
      contentVisible: false,
      typeForm: {},
      contentForm: {}
    }
  },
  created() {
    this.loadTypes().then(() => this.loadContents())
  },
  methods: {
    elUploadHttpRequest,
    typeName(id) {
      const t = (this.types || []).find(x => x.id === id)
      return t ? t.name : '-'
    },
    async loadTypes() {
      this.typeLoading = true
      try {
        const res = await listContentTypes()
        this.types = res.data || []
      } finally {
        this.typeLoading = false
      }
    },
    async loadContents() {
      this.contentLoading = true
      try {
        const res = await listContents({ typeId: this.filterTypeId || undefined })
        this.contents = res.data || []
      } finally {
        this.contentLoading = false
      }
    },
    openType(row) {
      this.typeForm = row
        ? { ...row }
        : { name: '', iconUrl: '', sortNo: 0, status: 'ON' }
      this.typeVisible = true
    },
    openContent(row) {
      this.contentForm = row
        ? { ...row }
        : { typeId: this.filterTypeId || (this.types[0] && this.types[0].id) || null, title: '', coverUrl: '', body: '', sortNo: 0, status: 'ON' }
      this.contentVisible = true
    },
    onTypeIcon(res) {
      const data = (res && res.data) || {}
      if (data.url) this.$set(this.typeForm, 'iconUrl', data.url)
    },
    onContentCover(res) {
      const data = (res && res.data) || {}
      if (data.url) this.$set(this.contentForm, 'coverUrl', data.url)
    },
    async saveType() {
      if (!this.typeForm.name) return this.$message.warning('请填写名称')
      this.saving = true
      try {
        await saveContentType(this.typeForm)
        this.$message.success('已保存')
        this.typeVisible = false
        this.loadTypes()
      } finally {
        this.saving = false
      }
    },
    async saveContent() {
      if (!this.contentForm.title || !this.contentForm.typeId) return this.$message.warning('请填写标题和类型')
      this.saving = true
      try {
        await saveContent(this.contentForm)
        this.$message.success('已保存')
        this.contentVisible = false
        this.loadContents()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.thumb { width: 56px; height: 40px; object-fit: cover; border-radius: 4px; }
.icon-thumb { width: 40px; height: 40px; object-fit: cover; border-radius: 8px; background: #f1f5f9; }
.icon-preview {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.icon-preview img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.muted { color: #94a3b8; }
.cover-preview {
  margin-top: 10px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.cover-preview img {
  width: 160px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
</style>
